/**
 * Created by admin on 2017/3/31.
 * 加密解密工具类
 */
import jsbridge from './jsbridge/jsbridge';
import CryptoJS from 'crypto-js';
import { isGomeApp } from './util';


const rsaKey = 'MIGfMA0GCSqGSIb3DQEBAQUAA4GNADCBiQKBgQC7mK/FpaUGw5kNUDuVs9H/OflISB9Rh2yMAl1Pi6DyF9m6h5MxNwd2SDEr2wlk+aRK79JcjPu1++00lONpFAt+lMrEBLvTMHZVQ+kWgVX0+jGKCab7xoKvlZTPNjlNz9N3u4g6KabBDXIZcJa/d8esZvzLss80SNQU89B+vq1NZQIDAQAB';
let aesKey = 'b2070e309409969b';
var aesKeyAes = 'AXjmiqa4wKtEYKQz2Pd21rS8smj9TGx8S';

export const encryptAllRsa = (content)=>{ // RSA 加密
    let encrypt = new JSEncrypt();
    encrypt.setPublicKey(rsaKey);
    let encryptContent = encrypt.encrypt(content);
    if(encryptContent){
        return encodeURIComponent(encryptContent);
    }
    return '';
};

export const encryptRsa = (content)=>{ // RSA 加密
    let encrypt = new JSEncrypt();
    encrypt.setPublicKey(rsaKey);
    let encryptContent = encrypt.encrypt(content);
    if(encryptContent){
        return encryptContent;
    }
    return '';
};

export const encryptDes = (content)=>{ // DES 解密
    return strDec(content , aesKey , '' , '');
};

function getKey (key) {
    let realKey = CryptoJS.SHA1(key);
    realKey = CryptoJS.SHA1(realKey).toString().substring(0, 32); //真正的key
    return realKey;
};

export const encryptAes = async (content) =>{ //aes加密
    let aesKey = sessionStorage['aesKey'] && sessionStorage['aesKey'];
    let key = getKey(aesKey);
    let encrypt = CryptoJS.AES.encrypt(content, CryptoJS.enc.Hex.parse(key), {
        mode: CryptoJS.mode.ECB,
        padding: CryptoJS.pad.Pkcs7
    });
    return encrypt.ciphertext.toString(CryptoJS.enc.Hex).replace(/\+/g, '%2B').replace(/\&/g, '%26');
};

export const decryptAes = async (content) => { //aes解密
    let aesKey = sessionStorage['aesKey'] && sessionStorage['aesKey'];
    var realKey = getKey(aesKey);
    var decrypt = CryptoJS.AES.decrypt(
        { ciphertext: CryptoJS.enc.Hex.parse(content) },
        CryptoJS.enc.Hex.parse(realKey),
        {
            mode: CryptoJS.mode.ECB,
            padding: CryptoJS.pad.Pkcs7
        }
    );
    return decrypt.toString(CryptoJS.enc.Utf8);
};

//用来加密aes(h5自己的aes,国美金融获取的aes)
export const encryptAesKey = async () =>{
    // if (isGomeApp || sessionStorage['source/from'] == 'app') {
    //     var aesObj;
    //     if (navigator.userAgent.indexOf('gomeFinancialVersion') > -1) {
    //         aesObj = await jsbridge.getAesSecretKey()
    //     } else {
    //         aesObj = JSON.stringify({code : '500'})
    //     }
    //     let keyapp = aesObj && typeof(aesObj) == 'string' && JSON.parse(aesObj).aeskey ? JSON.parse(aesObj).aeskey : 'K4aQvVkEwFYNn9PT';
    //     this.$store.commit('setAesKey', keyapp)
    // } else {
    let keyh5 = 'K4aQvVkEwFYNn9PT';
    sessionStorage['aesKey'] = keyh5;
    let key = getKey(aesKeyAes);
    let encrypt = CryptoJS.AES.encrypt(keyh5, CryptoJS.enc.Hex.parse(key), {
        mode: CryptoJS.mode.ECB,
        padding: CryptoJS.pad.Pkcs7
    });
    return encrypt.ciphertext.toString(CryptoJS.enc.Hex);
};

//用来加密uuid(h5自己的uuid,国美金融获取的uuid)
export const encryptAesUuid = async () =>{
    // if (isGomeApp || sessionStorage['source/from'] == 'app') {
    //     var aesObj;
    //     if (navigator.userAgent.indexOf('gomeFinancialVersion') > -1) {
    //         aesObj = await jsbridge.getAesSecretKey()
    //     } else {
    //         aesObj = JSON.stringify({code : '500'})
    //     }
    //     let keyapp = aesObj && typeof(aesObj) == 'string' && JSON.parse(aesObj).aeskey ? JSON.parse(aesObj).aeskey : 'K4aQvVkEwFYNn9PT';
    //     this.$store.commit('setAesKey', keyapp);
    // } else {}
    let uuid = '';
    sessionStorage['aseUuid'] = uuid;
    let key = getKey(aesKeyAes);
    let encrypt = CryptoJS.AES.encrypt(uuid, CryptoJS.enc.Hex.parse(key), {
        mode: CryptoJS.mode.ECB,
        padding: CryptoJS.pad.Pkcs7
    });
    return encrypt.ciphertext.toString(CryptoJS.enc.Hex);
};



// WEBPACK FOOTER //
// ./src/utils/encrypt.js